import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import _ from "i18n";
import Lottie from "react-lottie";
import styles from "./NotFound.local.scss";
import { TiArrowForward } from "react-icons/ti";
import * as error404Data from "../Common/lottie-animations/error-404.json";
import * as nothingFoundData from "../Common/lottie-animations/nothing-found.json";
import * as accessDenied from "../Common/lottie-animations/access-denied.json";

export default class NotFoundV2 extends Component {
  defaultOptions = {
    loop: true,
    autoplay: true
  };

  render() {
    let {
      mainClass,
      children,
      text,
      subText,
      errorPageType,
      isBalancePage
    } = this.props;
    let renderedTxt;

    switch (errorPageType) {
      case "ERROR_404":
        renderedTxt = (
          <div className={styles.not_found_v2__main}>
            <Lottie
              options={{ ...this.defaultOptions, animationData: error404Data }}
              height={360}
              isClickToPauseDisabled={true}
            />
            <h2>{_("Oops")}</h2>
            <h5>{_("gotLost")}</h5>
            <p>{_("pageNotFound")}</p>
            {!this.props.buttonIgnored ? (
              <button className="btn secondary">
                <i className="icon-arrow-left" /> &nbsp;&nbsp;&nbsp;&nbsp;
                <NavLink to="/">{_("goBack")}</NavLink>
              </button>
            ) : (
              ""
            )}
          </div>
        );
        break;

      case "ACCESS_DENIED":
        renderedTxt = (
          <div className={styles.not_found_v2__main}>
            <Lottie
              options={{ ...this.defaultOptions, animationData: accessDenied }}
              height={360}
              isClickToPauseDisabled={true}
            />
            <h2>{_("Oops")}</h2>
            {subText && <h5>{_(subText)}</h5>}
            <p
              style={{
                textAlign: "center",
                wordWrap: "break-word",
                width: isBalancePage ? "40%" : ""
              }}
            >
              {_(text)}
            </p>
            {/*<p>{_("accessDenied")}</p>*/}
            {!this.props.buttonIgnored ? (
              <button
                className="btn secondary"
                style={{ marginLeft: 12, marginTop: 10 }}
              >
                <i className="icon-arrow-left" /> &nbsp;&nbsp;&nbsp;&nbsp;
                <NavLink to="/">{_("goBack")}</NavLink>
              </button>
            ) : (
              ""
            )}
          </div>
        );
        break;
      case "NOTHING_FOUND":
        renderedTxt = (
          <div className={styles.not_found_v2__main}>
            <Lottie
              options={{ ...this.defaultOptions, animationData: accessDenied }}
              height={360}
              isClickToPauseDisabled={true}
            />
            <h2>{_("Oops")}</h2>
            {subText && <h5>{_(subText)}</h5>}
            <p>{_(text)}</p>
            {this.props.redirect ? (
              <button
                className="btn secondary"
                onClick={this.props.redirect}
                style={{ marginLeft: 12, marginTop: 10 }}
              >
                <TiArrowForward /> &nbsp;&nbsp;
                {_(this.props.buttonText)}
              </button>
            ) : (
              ""
            )}
          </div>
        );
        break;

      default:
        renderedTxt = (
          <div className={styles.not_found_v2__main}>
            <Lottie
              options={{
                ...this.defaultOptions,
                animationData: nothingFoundData
              }}
              height={360}
              isClickToPauseDisabled={true}
            />
            <h2>{_("noResult")}...</h2>
            <p>{_(text || "nothingFound")}</p>
          </div>
        );
        break;
    }

    return (
      <div className={`${styles.not_found_v2} ${mainClass}`}>
        {children || renderedTxt}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFoundV2.js